import PonchoIcon from "./PonchoIcon";

export default function DocumentoIcon({ ...props }) {
  return <PonchoIcon name="documento" {...props} />;
}
